import Headroom from 'headroom.js';
const myElement = document.querySelector('header');
const options = {
    tolerance: {
        up: 5,
        down: 60
    },
    classes: {
        initial: 'Header',
        pinned: 'Header--pinned',
        unpinned: 'Header--unpinned',
        top: 'Header--top',
        notTop: 'Header--not-top',
        bottom: 'Header--bottom',
        notBottom: 'Header--not-bottom',
        frozen: 'Header--frozen'
    }
};

const stickynav = new Headroom(myElement, options);

stickynav.init();
